__turbopack_context__.v({
  "active": "OurStoryItems-module__Q-dlUa__active",
  "item": "OurStoryItems-module__Q-dlUa__item",
  "itemContent": "OurStoryItems-module__Q-dlUa__itemContent",
  "itemContentContainer": "OurStoryItems-module__Q-dlUa__itemContentContainer",
  "itemIcons": "OurStoryItems-module__Q-dlUa__itemIcons",
  "items": "OurStoryItems-module__Q-dlUa__items",
  "smallGap": "OurStoryItems-module__Q-dlUa__smallGap",
});
